import React, { FunctionComponent, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Routing from 'routing/routing';
import { userManager } from '../../auth';
import { useMessagesEndpoint } from '../../hooks/useMessagesEndpoint';

const FslCallbackPage: FunctionComponent = () => {
  const navigate = useNavigate();
  const { postDraftMessage } = useMessagesEndpoint();
  const hasProcessedCallback = useRef(false);
  const isProcessing = useRef(false);

  useEffect(() => {
    // Prevent multiple processing of the same callback
    if (hasProcessedCallback.current || isProcessing.current) {
      console.log('FslCallbackPage - already processed or processing, skipping');
      return;
    }

    // Check if we're already on a non-callback URL (meaning we've been redirected)
    if (!window.location.pathname.includes('callback')) {
      console.log('FslCallbackPage - not on callback URL, skipping');
      return;
    }

    isProcessing.current = true;
    hasProcessedCallback.current = true;
    console.log('FslCallbackPage - processing callback');

    userManager
      .signinRedirectCallback()
      .then((user) => {
        console.log('Callback successful, user:', user);

        const messageMemberId = typeof user.state === 'string' ? user.state : undefined;

        if (messageMemberId) {
          const recipient = {
            memberId: messageMemberId,
          };

          return postDraftMessage('', '', false, [recipient], undefined).then((response) => {
            sessionStorage.removeItem('OnSigninRedirect');
            navigate(`${Routing.newMessage}/${response}`, { replace: true });
          });
        }

        // Get the stored redirect URL from sessionStorage (set in withOidc.tsx)
        const returnTo = sessionStorage.getItem('OnSigninRedirect');

        if (returnTo) {
          console.log('Redirecting to stored URL:', returnTo);
          sessionStorage.removeItem('OnSigninRedirect');
          navigate(returnTo, { replace: true });
        } else {
          console.log('No stored redirect, going to home');
          navigate('/', { replace: true });
        }

        return undefined;
      })
      .catch((error) => {
        console.error('Callback error:', error);
        navigate('/', { replace: true });
      })
      .finally(() => {
        isProcessing.current = false;
      });
  }, [navigate, postDraftMessage]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
      }}
    >
      Processing login...
    </div>
  );
};

export default FslCallbackPage;
